import { render, staticRenderFns } from "./onVttk.vue?vue&type=template&id=75a87082"
import script from "./onVttk.vue?vue&type=script&lang=js"
export * from "./onVttk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports